export default function chopAtWordBoundary(text, maxLength) {
  if (!text || text.length <= maxLength) {
    return text;
  }
  const spaceBeforeMax = text.lastIndexOf(' ', maxLength + 1);
  if (spaceBeforeMax < 1) {
    // whatever
    return text.substring(0, maxLength) + ' ...';
  } else {
    return text.substring(0, spaceBeforeMax) + ' ...';
  }
}
